import { Box, Button, Typography } from '@material-ui/core';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';
import { useStyles } from '../../../../styles';

interface ActionCardFooterProps {
  nextActionUrl?: string;
  hasWorkItems: boolean;
  actionText: string;
  onViewDetails: () => void;
}

export function ActionCardFooter({
  nextActionUrl,
  hasWorkItems,
  actionText,
  onViewDetails,
}: ActionCardFooterProps) {
  const classes = useStyles();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-3 w-full mb-2">
      <Box className={`rounded ${classes.actionFooterNoticeBox}`}>
        <Typography
          component="span"
          variant="body1"
          className={classes.actionFooterBoldText}
        >
          {'Action to be taken: '}
        </Typography>
        <Typography
          component="span"
          variant="body2"
          className={classes.actionFooterBodyText}
        >
          {actionText.trim()}
        </Typography>
      </Box>
      {hasWorkItems && (
        <Button
          variant="outlined"
          onClick={onViewDetails}
          className={classes.actionFooterButton}
          size="medium"
        >
          View Details
        </Button>
      )}
      {!hasWorkItems && nextActionUrl && (
        <Button
          variant="outlined"
          href={nextActionUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.actionFooterButton}
          size="medium"
        >
          Link
          <OpenInNewOutlinedIcon style={{ fontSize: 20, paddingLeft: '6px' }} />
        </Button>
      )}
    </div>
  );
}
